module.exports = __webpack_public_path__ + "static/media/cerberus_logo.4bb0af1f.png";